import React, { useEffect, useContext, useState, Suspense } from "react"
import { GlobalContext } from "@Context/context/GlobalState"
import AllInboxIcon from "@material-ui/icons/AllInbox"
import { useParams } from "react-router-dom"
import { useEnv } from "@Hooks"
import { getChannelbyID } from "@Services/channelService"
import { useTranslation } from "react-i18next"
import rsc from "@Config/resources"
import { useHistory } from "react-router"

import { LoadComponentByCondition } from "@Methods"
const Component = new LoadComponentByCondition("FormChannel").render()

const EditChannelScreen = () => {
  const { t } = useTranslation("global")
  const { handleErrorSession, handleRoutingBreadcrumbs } =
    useContext(GlobalContext)
  const { channelId } = useParams()
  const user = useEnv().multiclient.get_user()
  const [load, setLoad] = useState(true)
  const [info, setInfo] = useState(null)
  const history = useHistory()

  const { multiclient } = useEnv()

  useEffect(() => {
    if (
      !multiclient.permissions_v3_on(
        [rsc.CHANNEL, rsc.CHANNEL_BUTTON_EDIT_CHANNEL],
        [rsc.ChCrudEdit, rsc.CHANNEL_BUTTON_EDIT_CHANNEL],
      )
    ) {
      return history.goBack()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    handleRoutingBreadcrumbs({
      titleHeader: t("edit-sales-channel"),
      routes: [
        { name: t("inventory"), route: "/channels" },
        { name: t("edit-sales-channel"), route: "/channels/edit/" + channelId },
      ],
      icon: <AllInboxIcon style={{ marginRight: 5, opacity: 0.5 }} />,
    })
    getChannel()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getChannel = async () => {
    setLoad(true)
    try {
      const response = await getChannelbyID(user?.token, channelId)
      setInfo(response.data.message)
      setLoad(false)
    } catch (error) {
      handleErrorSession({
        error: true,
        errorCode: error.response.status,
      })
    }
  }

  return (
    <Suspense fallback>
      <Component info={info} edit={true} load={load} />
    </Suspense>
  )
}

export default EditChannelScreen
